import React, { useState } from 'react'
import FerryServiceForm from './FerryServiceForm'
import { INITIAL_VALUES, toRequestParams } from './form'
import { createFerryService } from 'services'
import { useErrorHandling } from 'context/errorHandling'
import { SuccessDialog } from 'components/Shared/Dialogs'
import { useTranslation } from 'react-i18next'
import { useNavigatePrevent } from 'context/navigatePrevent'

export function FerryServiceCreateForm () {
  const [successDialogOpen, setSuccessDialogOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  const { t } = useTranslation()
  const { handleError } = useErrorHandling()
  const { setNavigationUnlocked } = useNavigatePrevent()

  const handleSubmit = (values, onSuccess) => {
    setLoading(true)
    createFerryService(toRequestParams(values))
      .then(createdFerryService => onSuccess(createdFerryService.id)
        .then(() => setSuccessDialogOpen(true))
        .catch(handleError)
      )
      .catch(error => handleError(error))
      .then(() => setLoading(false))
  }

  const handleSuccessDialogClose = () => {
    setSuccessDialogOpen(false)
    setNavigationUnlocked(history => history.push('/ferry-services'))
  }

  return (
    <>
      <FerryServiceForm
        onSubmit={handleSubmit}
        initialValues={INITIAL_VALUES}
        title={t('ferryServices.form.createForm.title')}
        loading={loading}
      />
      <SuccessDialog
        content="ferryServices.form.createForm.successDialog.content"
        open={successDialogOpen}
        onClose={handleSuccessDialogClose}
      />
    </>
  )
}
